export default "__VITE_ASSET__075e79d1__"